module.exports = __webpack_public_path__ + "static/img/21.1ec1d18d.jpg";